import { render } from "./EventRegistration.vue?vue&type=template&id=6f9fe7cf&scoped=true"
import script from "./EventRegistration.vue?vue&type=script&lang=js"
export * from "./EventRegistration.vue?vue&type=script&lang=js"

import "./EventRegistration.vue?vue&type=style&index=0&id=6f9fe7cf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9fe7cf"]])

export default __exports__